import * as React from 'react';
import { OnlyOnPrint, PrintStyle } from '../../../../../designSystem/compositeComponents/Print';
import { buildTranslator, CustomForm, CustomFormAnswer } from '../../../../../amorg-common';
import { H1, H2 } from '../../../../../designSystem/typography/Heading';
import { getCustomFormSelectionOverview } from '../../../../../api/customFormClientApi';
import { customFormFieldFactory } from '../../../_components/customFormFieldFactory';
import { Flex } from '../../../../../designSystem/compositeComponents/FlexHelpers';

type PrintCustomFormAnswerPageProps = {
    form: CustomForm,
    siteId: string,
    answer:CustomFormAnswer,
    videoSubmissionEnabled:boolean,
    innerRef: React.Ref<HTMLDivElement>
}


export function PrintCustomFormAnswerPage(props: PrintCustomFormAnswerPageProps):JSX.Element
{
    
    const translator = buildTranslator('da');
    
    return (
        <>
        {props.answer &&
        <OnlyOnPrint>
            <PrintStyle ref={props.innerRef}>
           
            <Flex flexDirection="column" gap={16}>

                <Flex flexDirection="column" gap={16}>
                    <H1>{translator(props.form.name)}</H1>
                    <H2>{translator(props.form.description)}</H2>
                </Flex>                


                {props.form?.fields.map((field) =>
                    <Flex flexDirection='column' key={field.fieldId}>
                        {customFormFieldFactory.getAnswerFieldComponent(field, 
                            {
                                siteId:props.siteId,
                                form:props.form,
                                answer:props.answer,
                                disabled:false,
                                videoSubmissionEnabled:props.videoSubmissionEnabled,
                                inPrint:true,
                                doUpdate: async () => {return;},
                                onSubmit: async () => {return;},
                                getFieldOptions: async () => {
                                    return await getCustomFormSelectionOverview(props.siteId, props.form.id);
                                }
                            }
                        )}
                    </Flex>
                )}
                </Flex>
             
            </PrintStyle>
        </OnlyOnPrint>
        }  
        </>
    );
}